export const getUserBrowserDetails = () => {
  // User Agent string
  const userAgent = navigator.userAgent;
  // Browser language
  const browserLanguage = navigator.language || navigator.userLanguage;
  // Browser platform
  const browserPlatform = navigator.platform;
  // Browser Name and Version
  let browserName, browserVersion;

  // Check for Chrome
  if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
    browserName = "Google Chrome";
    browserVersion = userAgent.match(/Chrome\/(\d+)/)?.[1] || "N/A";
  }

  // Check for Firefox
  else if (/Firefox/.test(userAgent)) {
    browserName = "Mozilla Firefox";
    browserVersion = userAgent.match(/Firefox\/(\d+)/)?.[1] || "N/A";
  }

  // Check for Safari
  else if (
    /Safari/.test(userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  ) {
    browserName = "Apple Safari";
    browserVersion = userAgent.match(/Version\/(\d+)/)?.[1] || "N/A";
  }

  // Check for Edge (Chromium-based)
  else if (/Edg/.test(userAgent)) {
    browserName = "Microsoft Edge";
    browserVersion = userAgent.match(/Edg\/(\d+)/)?.[1] || "N/A";
  }

  // Check for Opera
  else if (/Opera/.test(userAgent) || /OPR/.test(userAgent)) {
    browserName = "Opera";
    browserVersion = userAgent.match(/(?:Opera|OPR)\/(\d+)/)?.[1] || "N/A";
  }

  // Check for Internet Explorer
  else if (/Trident/.test(userAgent)) {
    browserName = "Internet Explorer";
    browserVersion = userAgent.match(/rv:(\d+)/)?.[1] || "N/A";
  }

  // Default fallback
  else {
    browserName = "Unknown";
    browserVersion = "N/A";
  }

  return {
    browser_language: browserLanguage,
    browser_platform: browserPlatform,
    browser_name: `${browserName} v${browserVersion}`,
  };
};
